export const CONFIG = 'CONFIG'
export const CONFIG_STATUS = 'CONFIG_STATUS'
export const PLATFORM = 'PLATFORM'
export const PLATFORM_STATUS = 'PLATFORM_STATUS'
export const REVOKE_PLATFORM = 'REVOKE_PLATFORM'
export const REVOKE_PLATFORM_STATUS = 'REVOKE_PLATFORM_STATUS'
